<template>
    <!-- 修改关注 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body=true
      width="1110px"
      custom-class="custom-dialog"
    >
      <div slot="title" class="title">
        <div class="title-name">设置我的关注</div>
        <div class="side-title"></div>
        <div class="handle-btn"><!-- <i class="el-icon-s-tools" slot="reference" style="cursor:pointer"></i> --></div>
      </div>
      <i style="font-size: 12px; color: #aaa; line-height: 30px">(行业、公司、模块可多选，选择后点击空白即可)</i>
      <el-form :model="guanZhu" size="mini" label-width="80px">
        <el-form-item label="行业" prop="行业">
          <el-select v-model="guanZhu['行业']" multiple filterable style="width: 950px" @change="loadCompany">
            <el-option v-for="(hangye, k) in transferHangyes" :key="k" :label="hangye" :value="hangye"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司" prop="公司">
          <el-select v-model="guanZhu['公司']" multiple filterable style="width: 950px">
            <el-option v-for="(com, k) in companyData" :key="k" :label="com" :value="com"></el-option>
          </el-select>
          <el-button size="mini" type="text" @click="$refs.selectCompany.open()">批量增加公司</el-button>
        </el-form-item>
        <el-form-item label="模块" prop="模块">
          <el-select v-model="guanZhu['模块']" multiple filterable style="width: 950px">
            <el-option v-for="func in cateData" :key="func" :label="func" :value="func"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <selectCompany ref="selectCompany" @confirm="addCompany"></selectCompany>
      <span slot="footer">
        <el-button size="mini" @click="close">取消</el-button>
        <el-button type="primary" size="mini" @click="saveGuanzhu">保存</el-button>
      </span>
    </el-dialog>
</template>

<script>
import selectCompany from '../../../company/src/hunting/selectCompany'
export default {
    components: {selectCompany},
    data () {
        return {
            dialogVisible: false,
            guanZhu: {},
            cateData: [],
            companyData: [],
            transferHangyes: app.industries || [],
        }
    },
    created() {
        this.guanZhu = app.user.bulletinGuanzhu || {公司:[], 模块:[]}
        this.loadDefaultGuanzhu()
    },
    methods: {
        loadDefaultGuanzhu: async function(){
            let res = await app.service('misc').getKehuKaifaCompany()
            if (res.data && res.data.data) {
                this.guanZhu.公司 = [...this.guanZhu.公司, ...res.data.data]
                this.guanZhu.公司 = Array.from(new Set(this.guanZhu.公司))
            }
            if (app.user.SL权限) {
                this.guanZhu.模块 = [...this.guanZhu.模块, ...app.user.SL权限.split(';')]
                this.guanZhu.模块 = Array.from(new Set(this.guanZhu.模块))
            }
            // 加载公司列表和模块列表
            if (!app.categories) {
                await app.getCats()
            }
            this.cateData = ['全部'].concat(app.categories.map((cate) => cate['名称']))
            if (this.companyData.length === 0) {
                await this.loadCompany()
            }
        },
        getTime(time) {
            return time ? dateFormat(time, 'yyyy-mm-dd') : ''
        },
        handleSave(formData) {
            this.bulletinData.unshift(formData)
        },
        async showGuanzhu() {
            await app
                .service('project')
                .saveRecords({ type: '设置我的关注', path: '工作台-最新情报-设置我的关注', page: '工作台' })
            if (!app.categories) {
                await app.getCats()
            }
            this.cateData = ['全部'].concat(app.categories.map((cate) => cate['名称']))
            if (this.companyData.length === 0) {
                await this.loadCompany()
            }
        },
        async saveGuanzhu() {
            await app.service('users').patch(app.user._id, {
                bulletinGuanzhu: this.guanZhu,
            })
            app.user.bulletinGuanzhu = this.guanZhu
            this.close()
            this.$message('保存成功')
        },
        addCompany(company) {
            console.log(company)
            console.log()
            if (!this.guanZhu.公司) this.guanZhu.公司 = []
            this.guanZhu.公司 = Array.from(new Set(this.guanZhu.公司.concat(company)))
        },
        loadCompany: async function () {
            let res
            if (this.guanZhu['行业'] && this.guanZhu['行业'].length > 0) {
                res = await app.service('company').getCompanySimpleList({
                query: { 行业: this.guanZhu['行业'][0] },
                fields: { 简称: 1, 排名: 1 },
                sort: { 排名: 1 },
                })
            }
            if (!res || !res.data || res.data.length == 0) {
                res = await app.service('project').getDefaultCompanies()
            }
            this.companyData = res.data.map((item) => item['简称'])
        },
        close(){
            this.dialogVisible = false
        },
    },
    

}
</script>